/**
 * @fileoverview POST handler for the "/engagement/conversion_filter_preview" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementConversionFilterPreviewCacheKeys } from "./constants";
import type {
  PostEngagementConversionFilterPreviewProps,
  EngagementConversionFilterPreviewResponse,
} from "./types";

export const postEngagementConversionFilterPreview = reactQueryMutationAdapter(
  engagementConversionFilterPreviewCacheKeys,
  (props: PostEngagementConversionFilterPreviewProps): Promise<EngagementConversionFilterPreviewResponse> => {
    return fetch("/engagement/conversion_filter_preview", "POST", props);
  }
);
